<template>
    <el-header height="45"
               style="padding:0; display:flex; justify-content:flex-end; align-items:center;">
        <div style="display: inline">
            <template v-for="item in buttons">
                <!--二级下拉按钮-->
                <el-dropdown v-if="item.children && item.children.length>0"
                             :key="item.id"
                             :show-timeout="0"
                             :hide-timeout="300"
                             :hide-on-click="false"
                             size="mini"
                             placement="bottom-start"
                             trigger="click"
                             @command="handleOption">
                    <el-button size="mini"
                               plain
                               :title="item.buttonUrl"
                               :icon="item.buttonIcon ? 'mxvue-icon-'+item.buttonIcon : ''"
                               :type="(item.buttonCode.indexOf('delete')!==-1 || item.buttonCode.indexOf('remove')!==-1) ? 'danger' : 'primary'">
                        <span style="margin-left: 4px">{{ needI18n?generateButton(item.buttonCode):item.buttonName }}</span>
                        <i class="el-icon-caret-bottom el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="child in item.children"
                                          :key="child.id"
                                          :command="child.buttonUrl"
                                          :icon="child.buttonIcon ? 'mxvue-icon-'+child.buttonIcon : ''"
                                          :disabled="child.buttonCode.indexOf('batch-delete')!==-1 && multipleSelection.length===0">{{ needI18n?generateButton(child.buttonCode):child.buttonName }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <!--一级按钮-->
                <el-button v-else
                           size="mini"
                           plain
                           :key="item.id"
                           :title="item.buttonUrl"
                           :icon="item.buttonIcon ? 'mxvue-icon-'+item.buttonIcon : ''"
                           :type="(item.buttonCode.indexOf('delete')!==-1 || item.buttonCode.indexOf('remove')!==-1) ? 'danger' : 'primary'"
                           :disabled="item.buttonCode.indexOf('batch-delete')!==-1 && multipleSelection.length===0"
                           @click="handleOption(item.buttonUrl)">
                    <span style="margin-left: 4px">{{ needI18n?generateButton(item.buttonCode):item.buttonName }}</span>
                </el-button>
            </template>
        </div>
    </el-header>
</template>

<script>
export default {
    name: 'HeadButton',
    props: {
        needI18n: {
            type: Boolean,
            default: true
        },
        buttons: {
            type: Array,
            required: true
        },
        multipleSelection: {
            type: Array,
            required: true
        }
    },
    methods: {
        generateButton: function(name) {
            return this.generateName('route', name)
        },
        handleOption(button) {
            this.$emit('clickButton', button)
        }
    }
}
</script>

<style lang="scss">
.el-main {
    .page {
        .header-button {
            .el-header {
                .el-dropdown {
                    .el-button--mini {
                        padding: 7px 9px !important;
                    }
                }

                .el-button--mini {
                    padding: 7px 9px !important;
                }

                .el-button + .el-button,
                .el-button + .el-dropdown,
                .el-dropdown + .el-button,
                .el-dropdown + .el-dropdown {
                    margin-left: 7px !important;
                }
            }
        }
    }
}

.el-popper[x-placement^='bottom'] {
    margin-top: 1px !important;
    box-shadow: 2px 2px 5px #999 !important;
    border-radius: 3px !important;
}

.el-dropdown-menu {
    .el-dropdown-menu__item:focus,
    .el-dropdown-menu__item:not(.is-disabled):hover {
        background-color: var(--theme-color_gently) !important;
        color: var(--theme-color) !important;
    }

    .popper__arrow {
        display: none !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/HeadButton/button.vue